"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fonts_1 = __importDefault(require("./../fonts"));
const baseStyle = {
    color: "colorTextPrimary",
    fontFamily: fonts_1.default.regular,
};
const variants = {
    body1: {
        fontSize: {
            base: "xl",
            md: "4xl",
        },
    },
    body2: {
        fontSize: {
            base: "lg",
            md: "3xl",
        },
    },
    body23: {
        //same to body2 in :base, between body2 and body3 in :md
        fontSize: {
            base: "lg",
            md: "2xl",
        },
    },
    body3: {
        fontSize: {
            base: "md",
            md: "xl",
        },
    },
    body4: {
        fontSize: {
            base: "sm",
            md: "lg",
        },
    },
    body5: {
        fontSize: {
            base: "xs",
            md: "md",
        },
    },
    body6: {
        fontSize: {
            base: "2xs",
            md: "sm",
        },
    },
    body7: {
        fontSize: {
            base: "2xs",
            md: "xs",
        },
    },
    h1: {
        fontFamily: fonts_1.default.bold,
        fontSize: {
            base: "xl",
            md: "4xl",
        },
    },
    h2: {
        fontFamily: fonts_1.default.bold,
        fontSize: {
            base: "lg",
            md: "3xl",
        },
    },
    h23: {
        fontFamily: fonts_1.default.bold,
        //same to h2 in :base, between h2 and h3 in :md
        fontSize: {
            base: "lg",
            md: "2xl",
        },
    },
    h3: {
        fontFamily: fonts_1.default.bold,
        fontSize: {
            base: "md",
            md: "xl",
        },
    },
    h4: {
        fontFamily: fonts_1.default.bold,
        fontSize: {
            base: "sm",
            md: "lg",
        },
    },
    h5: {
        fontFamily: fonts_1.default.bold,
        fontSize: {
            base: "xs",
            md: "md",
        },
    },
    h6: {
        fontFamily: fonts_1.default.bold,
        fontSize: {
            base: "2xs",
            md: "sm",
        },
    },
};
const defaultProps = {
    variant: "body3",
};
exports.default = {
    baseStyle,
    variants,
    defaultProps,
};
